import React, { useEffect } from 'react';
import { Route, RouteProps, useLocation } from 'react-router-dom';
import { LoadableComponent } from '@loadable/component';

import { notifyRouteLoadEvents } from 'helpers/routeEvents';

import { FullscreenSpinner } from '../FullscreenSpinner';

interface IProps<T> extends RouteProps {
  component: React.ComponentType<T> | LoadableComponent<T>;
  componentProps?: T;
  isPrivate?: boolean;
  isRestricted?: boolean;
  isRestrictedDevice?: boolean;
}

export const DescriptorRoute = <T extends object>({
  component: Component,
  componentProps,
  isPrivate,
  isRestricted,
  ...routerProps
}: IProps<T>) => {
  const { pathname } = useLocation();

  useEffect(() => {
    notifyRouteLoadEvents(Component, pathname);
  }, [Component, pathname]);

  return (
    <Route
      {...routerProps}
      render={() => {
        return (
          // @ts-ignore
          <Component {...componentProps} fallback={<FullscreenSpinner />} />
        );
      }}
    />
  );
};
